function Footer() {
  return (
    <footer>
      <p className="footer_description">
        Motivated by{' '}
        <a
          href="https://www.youtube.com/c/TraversyMedia/videos"
          target="_blank"
          rel="noreferrer"
        >
          Traversy Media
        </a>
        , Coded by{' '}
        <a href="https://github.com/MirosBL45" target="_blank" rel="noreferrer">
          Miroslav Jovic
        </a>
      </p>
    </footer>
  );
}

export default Footer;
